import { motion } from 'framer-motion';
// VISIT — appointment + boutique info + newsletter, one quiet page.
export default function Visit() {
  return (
    <div className="bg-[#F2EBE0] text-[#1B1A18]">
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#6F7E62]/20">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B8654A] mb-4">— Visit</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.02em]">Come and <span className="italic text-[#6F7E62]">smell them</span>.</h1>
      </section>

      <section className="max-w-[1400px] mx-auto px-8 lg:px-14 py-20 grid md:grid-cols-2 gap-12">
        {[
          { c: 'Atelier · Les Lauves, Aix', a: 'Route de Cézanne, 13100', h: 'By appointment only · Tuesday — Friday', t: '+33 4 42 555 0184', img: 'https://images.pexels.com/photos/3373745/pexels-photo-3373745.jpeg?auto=compress&cs=tinysrgb&w=1600' },
          { c: 'Boutique · Paris', a: '14 rue de Tournon, 75006', h: 'Wednesday — Saturday · 11:00 — 19:00', t: '+33 1 555 0184', img: 'https://images.pexels.com/photos/4465137/pexels-photo-4465137.jpeg?auto=compress&cs=tinysrgb&w=1600' },
        ].map((s, i) => (
          <motion.div key={s.c} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
            <div className="aspect-[5/4] overflow-hidden mb-6"><img src={s.img} alt="" className="w-full h-full object-cover" loading="lazy" /></div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B8654A] mb-2">Lieu 0{i + 1}</p>
            <h2 className="font-serif text-4xl">{s.c}</h2>
            <p className="text-base text-[#1B1A18]/75 mt-4 leading-[1.7]">{s.a}</p>
            <p className="font-serif italic text-base text-[#6F7E62] mt-1">{s.h}</p>
            <p className="font-mono text-[11px] text-[#1B1A18]/55 mt-2">{s.t}</p>
          </motion.div>
        ))}
      </section>

      {/* Newsletter */}
      <section className="bg-[#E8E0D2] border-y border-[#6F7E62]/15 py-20">
        <div className="max-w-[820px] mx-auto px-8 lg:px-14 text-center">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B8654A] mb-4">— Une lettre, deux fois par an</p>
          <h2 className="font-serif text-4xl lg:text-6xl leading-tight">Two letters, <span className="italic text-[#6F7E62]">a year</span>.</h2>
          <p className="font-serif italic text-lg text-[#1B1A18]/65 mt-4 max-w-md mx-auto">A short letter from Solène at the spring distillation, and another at the autumn pour. Nothing else.</p>
          <form className="mt-10 max-w-md mx-auto flex items-end gap-3 border-b-2 border-[#6F7E62]/40" onSubmit={(e) => e.preventDefault()}>
            <input data-testid="skin-newsletter" type="email" placeholder="votre.adresse@exemple.com" className="flex-1 bg-transparent py-3 outline-none font-serif text-base text-[#1B1A18] placeholder:text-[#1B1A18]/30" />
            <button type="button" className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B8654A] hover:text-[#1B1A18] py-3">Subscribe →</button>
          </form>
        </div>
      </section>
    </div>
  );
}
